import { Alert } from '@ksyos/design-system';
import type { AddCarePathServiceSettingsType, IAddableServiceGroupServiceRights } from '@common/interfaces';
import type { IEmployment } from '@frontend/components/interfaces';
import { AddRightsSteps as AddRightStepsType } from '@frontend/components/interfaces';
import { getSelectedLanguage } from '@frontend/translate';
import { AddServiceEmploymentSettings } from './AddServiceEmploymentSettings';
import { AddSettings } from './AddSettings';
import { ChooseRights } from './ChooseRights';
import { PersonalSettingsAddRightsOrganizationSettings } from './PersonalSettingsAddRightsOrganizationSettings';

export interface IAddRightsStepsProps {
    addableServiceGroupServiceRights?: IAddableServiceGroupServiceRights;
    currentStep: AddRightStepsType;
    employment?: IEmployment;
    onChange: (settings: AddCarePathServiceSettingsType, errorPath?: string) => void;
}

export function AddRightsSteps(props: IAddRightsStepsProps) {
    const { addableServiceGroupServiceRights, currentStep, employment, onChange } = props;

    if (currentStep === AddRightStepsType.addRights && addableServiceGroupServiceRights) {
        return (
            <>
                <ChooseRights addableServiceGroupServiceRights={addableServiceGroupServiceRights} />
                <AddSettings
                    employmentStartDate={employment?.startDate}
                    onChange={onChange}
                />

                {addableServiceGroupServiceRights.serviceEmploymentActivities.length > 0 && (
                    <AddServiceEmploymentSettings addableServiceGroupServiceRights={addableServiceGroupServiceRights} />
                )}
            </>
        );
    }
    if (currentStep === AddRightStepsType.organizationSettings) {
        return (
            <>
                <Alert appearance="info">
                    {getSelectedLanguage().personalSettings.alertMissingServiceOrganizationSettings}
                </Alert>
                <PersonalSettingsAddRightsOrganizationSettings />
            </>
        );
    }

    return <></>;
}
